export default {
  form: {
    address: {
      label: 'Adresse',
      placeholder: 'Adresse',
    },
    zip_code: {
      label: 'Postnr.',
      placeholder: 'Postnr.',
    },
    city: {
      label: 'By',
      placeholder: 'By',
    },
    start_time: {
      label: 'Starttidspunkt',
      placeholder: 'f.eks. 11:00',
    },
    name: {
      label: 'Lokationens navn (valgfrit)',
      placeholder: 'f.eks. Ved siden af Fernsehturm',
      tooltip:
        'Hvis du angiver et navn på lokationen, kan kunderne lettere genkende stedet, f.eks. „Ved siden af Fernsehturm“',
    },
    note: {
      label: 'Note',
      placeholder: 'Indtast note',
    },
  },
  buttons: {
    add_location: 'Tilføj lokation',
  },
};
